import type { Effect, Reducer } from 'umi'
import { filterInvalid, goQuery } from 'bv-utils'
import type { ObjectMap } from 'bv-typings'

export type FilterModelState = ObjectMap | undefined

export type FilterModelType = {
  namespace: 'filter';
  state: FilterModelState;
  effects: {
    set: Effect;
    clear: Effect;
    query: Effect;
  };
  reducers: {
    save: Reducer<FilterModelState>;
    reset: Reducer<any>;
  };
}

const FilterModel: FilterModelType = {
  namespace: 'filter',
  state: { currentUser: null },
  effects: {
    *set({ payload }, { select, put }) {
      const filters = filterInvalid(payload)
      // @ts-ignore add TS check, handle history code
      const values: any = yield select((state: any) => state.filter)
      if (filters.currentPage && filters.pageSize !== values.pageSize) { // 有参数变化时， 页码回到默认
        delete filters.currentPage
      }
      yield put({ type: 'query', payload: filters })
    },
    *clear({ payload }, { put }) {
      try {
        yield put({ type: 'reset' })
      } finally {
        const filters = filterInvalid(payload)
        yield put({ type: 'query', payload: filters })
      }
    },
    *query({ payload }, { put }) {
      try {
        yield put({ type: 'save', payload })
      } finally {
        goQuery(payload)
      }
    },
  },

  reducers: {
    reset() {
      return {}
    },
    save(state, action) {
      return { ...action.payload }
    },
  },
}

export default FilterModel
